import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=f83bbbfa&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=f83bbbfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83bbbfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f83bbbfa')) {
      api.createRecord('f83bbbfa', component.options)
    } else {
      api.reload('f83bbbfa', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=f83bbbfa&scoped=true&", function () {
      api.rerender('f83bbbfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bS5Yfld3f82Y/JS/comp/GuestBox.vue"
export default component.exports